import React, { useState } from 'react';
import ReCAPTCHA from "react-google-recaptcha";//NEW
import hat from "../../../assets/img/graudation-hat-2.svg";
import { useNavigate } from "react-router";
import  UtilityService  from '../../../services/UtillityServices/UtilityService';
import { Button, Spinner } from 'react-bootstrap';
import useAuth from '../../../hooks/useAuth';
import { alertService } from '../../../services/AlertService';

const RegistratiForm = ({onFetchData}) => {
  const navigate = useNavigate();
  const [cognome, setCognome] = useState('');//NEW
  const [nome, setNome] = useState('');//NEW
  const [agenzia, setAgenzia] = useState('');//NEW
  const [indirizzo, setIndirizzo] = useState('');//NEW
  const [cap, setCap] = useState('');//NEW
  const [citta, setCitta] = useState('');//NEW
  const [provincia, setProvincia] = useState('');//NEW
  const [email, setEmail] = useState('');
  const [repeatEmail, setRepeatEmail] = useState('');
  const [telefono, setTelefono] = useState('');//NEW
  const [password, setPassword] = useState('');
  const [privacyAccepted, setPrivacyAccepted] = useState(false);//NEW
  const {register, loadingState} = useAuth();
  const {requestForm, loadingStateForm} = useAuth();//NEW
  const [recaptchaToken, setRecaptchaToken] = useState(null);//NEW

  const onRegister = async () => {
    if(localStorage.getItem("idSP") > 0){//NEW
      if (!privacyAccepted) {
        alertService.warn("Devi accettare le condizioni sulla privacy per procedere", { autoClose: true });
        return;
      }
      if (!recaptchaToken) {
        alertService.warn("Completa il reCAPTCHA per continuare", { autoClose: true });
        return;
      }
      if(cognome.trim() !== '' && nome.trim() !== '' && agenzia.trim() !== '' && indirizzo.trim() !== '' && cap.trim() !== '' && citta.trim() !== '' && provincia.trim() !== '' && telefono.trim() !== '' && email.trim() !== '' && privacyAccepted){
        if(!UtilityService.isValidEmail(email)) {
          alertService.warn("L'email non è valida", { autoClose: true });
          return;
        }
        const obj = { cognome, nome, agenzia, indirizzo, cap, citta, provincia, telefono, email, idSP:localStorage.getItem("idSP"), privacyAccepted }
        console.log(obj);
        const fetchData = await requestForm(obj);
        if(fetchData?.id) {
          onFetchData(fetchData);
          alertService.success("Richiesta inoltrata con successo", { autoClose: true });
          navigate('/accedi');
        }
      }
    }
    else{
      if(email.trim() !== '' && repeatEmail.trim() !== '' && password.trim() !== ''){
        if (email !== repeatEmail) {
          alertService.warn("Le email non coincidono", {autoClose: true});
          return;
        }
        if(!UtilityService.isValidEmail(email)) {
          alertService.warn("L'email non è valida", { autoClose: true });
          return;
        }
        const obj = { username: email, password }
        const fetchData = await register(obj);
        if(fetchData?.id) {
          onFetchData(fetchData);
        }
      }
    }
  };

  if(localStorage.getItem("idSP") > 0){
    return (
      <>
        <div className="d-flex justify-content-center">
          <h2 className="text-center my-3"> <b>Richiesta credenziali di accesso partner</b></h2>
        </div>
        <div className="d-flex">
          <i className="bi fs-5 align-self-center me-2 text-muted"></i>
          <input 
            required 
            className="form-control form-control-lg my-2" 
            type="text" 
            placeholder="Agenzia" 
            aria-label="Agenzia"
            value={agenzia}
            onChange={(e) => setAgenzia(e.target.value)}
          />
        </div>
        <div className="d-flex">
          <i className="bi fs-5 align-self-center me-2 text-muted"></i>
          <input 
            required 
            className="form-control form-control-lg my-2" 
            type="text" 
            placeholder="Indirizzo" 
            aria-label="Indirizzo"
            value={indirizzo}
            onChange={(e) => setIndirizzo(e.target.value)}
          />
        </div>
        <div className="d-flex">
          <i className="bi fs-5 align-self-center me-2 text-muted"></i>
          <input 
            required 
            className="form-control form-control-lg my-2" 
            type="text" 
            placeholder="c.a.p." 
            aria-label="c.a.p."
            value={cap}
            onChange={(e) => setCap(e.target.value)}
          />
        </div>
        <div className="d-flex">
          <i className="bi fs-5 align-self-center me-2 text-muted"></i>
          <input 
            required 
            className="form-control form-control-lg my-2" 
            type="text" 
            placeholder="Città" 
            aria-label="Città"
            value={citta}
            onChange={(e) => setCitta(e.target.value)}
          />
        </div>
        <div className="d-flex">
          <i className="bi fs-5 align-self-center me-2 text-muted"></i>
          <input 
            required 
            className="form-control form-control-lg my-2" 
            type="text" 
            placeholder="Provincia" 
            aria-label="Provincia"
            value={provincia}
            onChange={(e) => setProvincia(e.target.value)}
          />
        </div>
        <div className="d-flex">
          <i className="bi fs-5 align-self-center me-2 text-muted"></i>
          <input 
            required 
            className="form-control form-control-lg my-2" 
            type="text" 
            placeholder="Cognome referente" 
            aria-label="Cognome referente"
            value={cognome}
            onChange={(e) => setCognome(e.target.value)}
          />
        </div>
        <div className="d-flex">
          <i className="bi fs-5 align-self-center me-2 text-muted"></i>
          <input 
            required 
            className="form-control form-control-lg my-2" 
            type="text" 
            placeholder="Nome referente" 
            aria-label="Nome referente"
            value={nome}
            onChange={(e) => setNome(e.target.value)}
          />
        </div>
        <div className="d-flex">
          <i className="bi fs-5 align-self-center me-2 text-muted"></i>
          <input 
            required 
            className="form-control form-control-lg my-2" 
            type="text" 
            placeholder="Telefono" 
            aria-label="Telefono"
            value={telefono}
            onChange={(e) => setTelefono(e.target.value)}
          />
        </div>
        <div className="d-flex">
          <i className="bi fs-5 align-self-center me-2 text-muted"></i>
          <input 
            required 
            className="form-control form-control-lg my-2" 
            type="text" 
            placeholder="E-mail" 
            aria-label="E-mail"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </div>
        <div className="form-check mt-3">
          <input 
            className="form-check-input" 
            type="checkbox" 
            id="privacyCheck"
            checked={privacyAccepted}
            onChange={(e) => setPrivacyAccepted(e.target.checked)}
          />
          <label className="form-check-label" htmlFor="privacyCheck">
            Accetto l'<a href="https://www.he-formazione.it/informativa-privacy" target="_blank" rel="noopener noreferrer">informativa privacy</a>
          </label>
        </div>
        <div className="my-3">
          <ReCAPTCHA
            sitekey="6LdVKQYrAAAAAGKk4JhxXstBzAHUR-FE4Ki5i_xr"
            onChange={(token) => setRecaptchaToken(token)}
          />
        </div>
      {loadingStateForm.isLoadingRequestForm ? (
        <Button variant="primary" disabled className="my-3 w-100">
          <Spinner
              as="span"
              animation="border"
              size="sm"
              role="status"
              aria-hidden="true"
              className="me-2"
          />
          Registrazione...
      </Button>
      ) : (
          <Button type="button" onClick={onRegister} className="btn btn-primary my-3 w-100">
              Richiedi
          </Button>
      )}
        <p><span className='text-muted'>Hai già un account?</span> <span role='button' onClick={() => navigate("/accedi")}><u>Accedi</u></span></p>
      </>
    );
  }

  return (
    <>
      <div className="d-flex justify-content-center">
        <h2 className="text-center my-3"> <b>Benvenuto</b></h2>
        <img src={hat} width="72" alt="" />
      </div>
      <div className="d-flex">
        <i className="bi bi-envelope fs-5 align-self-center me-2 text-muted"></i>
        <input 
          required 
          className="form-control form-control-lg my-2" 
          type="text" 
          placeholder="E-mail" 
          aria-label="E-mail"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
      </div>
      <div className="d-flex my-2">
        <i className="bi bi-envelope fs-5 align-self-center me-2 text-muted"></i>
        <input 
          required 
          className="form-control form-control-lg my-2" 
          type="text" 
          placeholder="Ripeti e-mail" 
          aria-label="Ripeti E-mail" 
          value={repeatEmail}
          onChange={(e) => setRepeatEmail(e.target.value)}
        />
      </div>
      <div className="d-flex">
        <i className="bi bi-key fs-5 align-self-center me-2 text-muted"></i>
        <input 
          required 
          type="password" 
          placeholder="Password" 
          className="form-control form-control-lg my-2" 
          aria-describedby="passwordHelpBlock" 
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
      </div>
      <small className="text-muted d-block mt-2">
          La tua password deve avere lunghezza minima 8 caratteri e avere al suo interno:<br></br>- una lettera minuscola<br></br>- una lettera maiuscola<br></br>- un numero<br></br>- un carattere speciale tra: <strong>! @ # $ % ^ * ( ) - _ + = ?</strong>
      </small>
      {loadingState.isLoadingRegister ? (
    <Button variant="primary" disabled className="my-3 w-100">
        <Spinner
            as="span"
            animation="border"
            size="sm"
            role="status"
            aria-hidden="true"
            className="me-2"
        />
        Registrazione...
    </Button>
    ) : (
        <Button type="button" onClick={onRegister} className="btn btn-primary my-3 w-100">
            Registrati
        </Button>
    )}
      <p><span className='text-muted'>Hai già un account?</span> <span role='button' onClick={() => navigate("/accedi")}><u>Accedi</u></span></p>
    </>
  );
};

export default RegistratiForm;
